
import { styled } from '@mui/material'

export const StyledHeader = styled('div')`
  display: flex;
  width: 100%;
  height: ${({ theme }) => theme.typography.pxToRem(62)};
  align-items: center;
  background-color: ${props => props.theme.palette.background.paper};
  box-shadow: ${props => props.theme.shadows[2]};
  border-bottom: 1px solid ${props => props.theme.palette.divider};
`

export const StyledContainer = styled('div')`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  margin: 0;
`